// extracted by mini-css-extract-plugin
export default {"HeaderIntro2":"HeaderIntro2_HeaderIntro2__nVGe3","Container":"HeaderIntro2_Container__n2Ma-","Img":"HeaderIntro2_Img__E3Rtt","Para":"HeaderIntro2_Para__9DfiF"};